import type { Permission } from '@ztechapps/common.contract'

/**
 * QuickScore access permission. Assigned to every newly-registered teacher and to
 * the app-service-user seed; marks a user as allowed to use the QuickScore API
 * (assessments, answer keys, scanning/grading, and export).
 */
export const quickscorePermissions = {
  canAccess: {
    value: 'quickscore.canAccess',
    label: 'Can Access',
    description: 'Allows the user to access the QuickScore API (assessments, scanning, grading, and export).',
  } satisfies Permission,

  quickscoreAdmin: {
    canAccess: {
      value: 'quickscoreAdmin.canAccess',
      label: 'Can Access',
      description: 'Allows the user to access the QuickScore admin app.',
    } satisfies Permission,
  },
}
